module.exports = __webpack_public_path__ + "static/img/background.888f6fe7.svg";